export const COUNT_MAX_DECIMALS_PLANS_FACTS_EDITING = 8;